/**
 * Unxage — Hover Size Selector
 * Reads availability from data-available on hover pills —
 * no fetch, no race condition. CSS injected before quickview
 * opens so styles are ready when labels render.
 */
(function () {
  'use strict';

  function injectSoldOutCSS(availability) {
    var old = document.getElementById('unxage-qv-sold-out');
    if (old) old.remove();

    var css = '';
    Object.keys(availability).forEach(function (size) {
      if (!availability[size]) {
        var safe = size.replace(/"/g, '\\"');
        css += '#jsQuickview label[data-value="' + safe + '"]'
             + '{opacity:0.35!important;text-decoration:line-through!important;'
             + 'pointer-events:none!important;cursor:not-allowed!important;}\n';
      }
    });

    if (!css) return;
    var el = document.createElement('style');
    el.id = 'unxage-qv-sold-out';
    el.textContent = css;
    document.head.appendChild(el);
  }

  function getLabelVal(label) {
    var dv = label.getAttribute('data-value');
    if (dv && dv.trim()) return dv.trim();
    var text = '';
    label.childNodes.forEach(function (n) {
      if (n.nodeType === 3) text += n.nodeValue;
    });
    return text.trim() || label.textContent.trim();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.unxage-sz');
    if (!btn || btn.classList.contains('unxage-sz--out')) return;

    var card = btn.closest('.js-product-card');
    if (!card) return;

    card.querySelectorAll('.unxage-sz').forEach(function (b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    var atcBtn = card.querySelector('.js-grid-cart');
    if (atcBtn && btn.dataset.vid) atcBtn.dataset.id = btn.dataset.vid;

    var selectedSize = btn.dataset.size || btn.textContent.trim();

    // Build availability map from hover pills — synchronous, no fetch
    var availability = {};
    card.querySelectorAll('.unxage-sz').forEach(function (pill) {
      var size = pill.dataset.size || pill.textContent.trim();
      availability[size] = (pill.getAttribute('data-available') === 'true');
    });

    // Inject CSS BEFORE opening quickview
    injectSoldOutCSS(availability);

    var qvBtn = card.querySelector('.js-btn-quickview');
    if (!qvBtn) return;

    // Open quickview
    qvBtn.click();

    // Poll for labels and pre-select clicked size
    // Also apply inline styles as backup in case CSS selector misses
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (attempts > 25) { clearInterval(poll); return; }

      var labels = document.querySelectorAll('#jsQuickview label');
      if (!labels.length) return;
      clearInterval(poll);

      labels.forEach(function (label) {
        var val = getLabelVal(label);
        if (val && availability[val] === false) {
          label.setAttribute('style',
            'opacity:0.35!important;'
            + 'text-decoration:line-through!important;'
            + 'pointer-events:none!important;'
            + 'cursor:not-allowed!important;'
          );
        }
      });

      // Pre-select clicked size
      for (var i = 0; i < labels.length; i++) {
        if (getLabelVal(labels[i]) === selectedSize) {
          labels[i].click();
          break;
        }
      }
    }, 100);
  });
})();